/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSizeProps} from '../types/types';
import useIconSize from './useIconSize';

/*
 * Defines the Design Language System (DLS) Notification Connectivity Icon component.
 */
export const NotificationConnectivityIcon = ({size}: IconSizeProps) => {
  const iconSize = useIconSize(size);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M8.78544 17.1219C7.80653 16.5575 6.99352 15.7452 6.42825 14.7668C5.86299 13.7884 5.56543 12.6783 5.56543 11.5484C5.56543 10.4184 5.86299 9.30838 6.42825 8.32997C6.99352 7.35155 7.80653 6.53927 8.78544 5.97485'
        stroke={dlsColor('grey1')}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d='M15.2095 5.96509C16.193 6.52818 17.0102 7.34109 17.5786 8.3215C18.1471 9.30192 18.4464 10.4151 18.4464 11.5483C18.4464 12.6816 18.1471 13.7948 17.5786 14.7752C17.0102 15.7556 16.193 16.5685 15.2095 17.1316'
        stroke={dlsColor('grey1')}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d='M12.0026 13.74C13.2102 13.74 14.1892 12.761 14.1892 11.5534C14.1892 10.3457 13.2102 9.3667 12.0026 9.3667C10.7949 9.3667 9.81592 10.3457 9.81592 11.5534C9.81592 12.761 10.7949 13.74 12.0026 13.74Z'
        stroke={dlsColor('grey1')}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d='M6.50198 21.0859C4.82904 20.1192 3.43997 18.7293 2.4742 17.0559C1.50843 15.3824 1 13.4843 1 11.5521C1 9.61996 1.50843 7.72182 2.4742 6.04835C3.43997 4.37488 4.82904 2.985 6.50198 2.01831'
        stroke={dlsColor('grey1')}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
      <path d='M17.4644 2C19.1464 2.96405 20.5442 4.35517 21.5162 6.03265C22.4883 7.71013 23.0002 9.6145 23.0002 11.5533C23.0002 13.492 22.4883 15.3964 21.5162 17.0739C20.5442 18.7513 19.1464 20.1425 17.4644 21.1065'
        stroke={dlsColor('grey1')}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
    </svg>
  );
};
